import { List } from 'react-virtualized';

export default class ForceScroller {

    private static RETRY_DELAY_MS = 800;

    private scrollTop = 0;
    private lastScrollTop = 0;
    private scrollIndex = -1;
    private retryTimer: NodeJS.Timer;

    public setListScrollTop(scrollTop: number): void {
        this.scrollTop = scrollTop;
    }

    public scrollToRow(list: List, rowIndex: number): void {
        this.cancelScroll();
        this.scrollIndex = rowIndex;
        this.startScrolling(list);
    }

    public restartScroll(list: List): void {
        if (this.isScrolling()) {
            this.scrollToRow(list, this.scrollIndex);
        }
    }

    public isScrolling(): boolean {
        return this.scrollIndex !== -1;
    }

    public cancelScroll(): void {
        this.scrollIndex = -1;
        clearTimeout(this.retryTimer);
    }

    private startScrolling(list: List): void {
        list.scrollToRow(this.scrollIndex);
        this.retryTimer = setTimeout(() => this.retryScroll(list), ForceScroller.RETRY_DELAY_MS);
    }

    private retryScroll(list: List): void {
        if (!this.isScrolling() || this.scrollTop === this.lastScrollTop) {
            this.cancelScroll();
        } else {
            this.lastScrollTop = this.scrollTop;
            this.startScrolling(list);
        }
    }
}
